module.exports = __webpack_public_path__ + "assets/5443f77b4bedfac845a85dbcccf39679.mp3";